import React, { useState } from "react";
import { PublicKey, Connection } from "@solana/web3.js";
import styles from "./css/Checkpayment.module.css";

export default function CheckPayment() {
  const walletAddress = new PublicKey(
    "4GX1hDmkpCaRDcNHdjMDeXP19FXh56xbZGRpsK5nmdyq",
  );
  const [orderId, setOrderId] = useState("");
  const [status, setStatus] = useState("");

  const checkPayment = async () => {
    if (!orderId) {
      setStatus("Please enter your order ID.");
      return;
    }

    setStatus("Checking payment...");

    try {
      const connection = new Connection(
        "https://sparkling-fragrant-sailboat.solana-mainnet.quiknode.pro/f6cbd527f9394680d0976261ba666bd0a298b298/",
        "confirmed",
      );

      // Get recent signatures for your wallet
      const signatures = await connection.getSignaturesForAddress(
        walletAddress,
        { limit: 50 },
      );

      for (const sigInfo of signatures) {
        const tx = await connection.getParsedTransaction(sigInfo.signature, {
          commitment: "confirmed",
          maxSupportedTransactionVersion: 0,
        });
        if (!tx) continue;

        // Convert transaction to string and check if memo contains orderId
        const txString = JSON.stringify(tx.transaction.message.instructions);
        if (txString.includes(orderId)) {
          setStatus(`✅ Payment received! Transaction: ${sigInfo.signature}`);
          return;
        }
      }

      setStatus("❌ Payment not found yet. Try again in a few seconds.");
    } catch (err) {
      console.error(err);
      setStatus("Error checking payment.");
    }
  };

  return (
    <div className={styles.checkpaymentcontainer}>
      <h3>Check Your Payment</h3>
      <input
        type="text"
        placeholder="Enter Order ID"
        value={orderId}
        onChange={(e) => setOrderId(e.target.value)}
        style={{ width: 300, marginRight: 10, padding: 6 }}
      />
      <button
        onClick={checkPayment}
        className="btn btn-warning text-black fw-bold rounded-0"
      >
        Check
      </button>
      <p>{status}</p>
    </div>
  );
}



// newly generated code for contract balance, not used in the app yet

// import React, { useState } from "react";
// import { PublicKey, Connection } from "@solana/web3.js";
// import styles from "./css/Checkpayment.module.css";

// // Replace with your new QuickNode URL
// const QUICKNODE_RPC_URL =
//   "https://sparkling-fragrant-sailboat.solana-mainnet.quiknode.pro/f6cbd527f9394680d0976261ba666bd0a298b298/";

// export default function CheckPayment() {
//   const walletAddress = new PublicKey(
//     "4GX1hDmkpCaRDcNHdjMDeXP19FXh56xbZGRpsK5nmdyq"
//   );
//   const [orderId, setOrderId] = useState("");
//   const [status, setStatus] = useState("");
//   const [loading, setLoading] = useState(false);

//   const checkPayment = async () => {
//     if (!orderId.trim()) {
//       setStatus("⚠ Please enter your order ID.");
//       return;
//     }

//     setStatus("");
//     setLoading(true);

//     try {
//       const connection = new Connection(QUICKNODE_RPC_URL, "confirmed");

//       // Fetch last 20 transactions to avoid rate limits
//       const signatures = await connection.getSignaturesForAddress(walletAddress, {
//         limit: 20,
//       });

//       if (signatures.length === 0) {
//         setStatus("❌ No recent transactions found for this wallet.");
//         setLoading(false);
//         return;
//       }

//       let found = false;

//       for (const sigInfo of signatures) {
//         const tx = await connection.getParsedTransaction(sigInfo.signature, {
//           commitment: "confirmed",
//           maxSupportedTransactionVersion: 0,
//         });

//         if (!tx) continue;

//         const instructions = tx.transaction.message.instructions;

//         for (const ix of instructions) {
//           if (ix.program === "spl-memo" && ix.parsed) {
//             const memoText = ix.parsed;

//             if (memoText.includes(orderId)) {
//               setStatus(`✅ Payment received! Transaction: ${sigInfo.signature}`);
//               found = true;
//               break;
//             }
//           }
//         }

//         if (found) break;
//       }

//       if (!found) {
//         setStatus("❌ Payment not found yet. Try again in a few seconds.");
//       }
//     } catch (err) {
//       console.error("Error checking payment:", err);
//       setStatus("❌ Error checking payment. Check console for details.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className={styles.checkpaymentcontainer}>
//       <h3>Check Your Payment</h3>
//       <input
//         type="text"
//         placeholder="Enter Order ID"
//         value={orderId}
//         onChange={(e) => setOrderId(e.target.value)}
//         style={{ width: 300, marginRight: 10, padding: 6 }}
//       />
//       <button
//         onClick={checkPayment}
//         className="btn btn-warning text-black fw-bold rounded-0"
//         disabled={loading}
//       >
//         {loading ? "Checking..." : "Check"}
//       </button>
//       <p>{status}</p>
//     </div>
//   );
// }
